// @refresh reset
import {createMultiStyleConfigHelpers, defineStyle} from '@chakra-ui/styled-system';
import {mode} from '@chakra-ui/theme-tools';
import {lightTokens, darkTokens} from '@linx-security/ui';

import {paginationAnatomy} from './anatomy';

const {defineMultiStyleConfig} = createMultiStyleConfigHelpers(paginationAnatomy.keys());

const light = lightTokens.components.pagination;
const dark = darkTokens.components.pagination;

const itemStyle = defineStyle(props => {
  const disabled = {
    cursor: `not-allowed`,
    backgroundColor: mode(light[`background-disabled`], dark[`background-disabled`])(props),
    color: mode(light[`text-disabled`], dark[`text-disabled`])(props),
  };

  return {
    display: `flex`,
    height: `1.5rem`,
    py: `space-100`,
    px: `space-150`,
    flexShrink: 0,
    justifyContent: `center`,
    alignItems: `center`,
    gap: `space-100`,
    borderRadius: `radius-rounded`,

    _disabled: disabled,
    _active: {
      backgroundColor: mode(light[`background-pressed`], dark[`background-pressed`])(props),
      color: mode(light[`text-pressed`], dark[`text-pressed`])(props),
      _disabled: disabled,
    },
    _hover: {
      backgroundColor: mode(light[`background-hover`], dark[`background-hover`])(props),
      color: mode(light[`text-hover`], dark[`text-hover`])(props),
      _disabled: disabled,
    },
    [`&[data-selected]`]: {
      backgroundColor: mode(light[`background-active`], dark[`background-active`])(props),
      color: mode(light[`text-active`], dark[`text-active`])(props),
      _disabled: disabled,
    },
  };
});

const triggerStyle = defineStyle(() => ({
  // Defined in the buttonTheme since pagination is using the Button component
  display: `flex`,
  alignItems: `center`,
  justifyContent: `center`,
}));

const ellipsisStyle = defineStyle(props => ({
  color: mode(light[`text-default`], dark[`text-default`])(props),
  fontSize: `sm`,
  fontWeight: `normal`,
  lineHeight: `1.5rem`,
}));

const rootStyle = defineStyle(() => ({
  display: `flex`,
  fontSize: `sm`,
  gap: `space-100`,
  '--pagination-skeleton-height': `24px`,
}));

export const paginationTheme = defineMultiStyleConfig({
  baseStyle: props => ({
    item: itemStyle(props),
    trigger: triggerStyle(),
    ellipsis: ellipsisStyle(props),
    root: rootStyle(),
  }),
});
